import React from "react";
import dyslexiaIcon from "../../../../components/Reports/containers/Assignment/icons/dyslexia.png";
import comprehensionIcon from "../../../../components/Reports/containers/Assignment/icons/comprehension.png";
import decodingIcon from "../../../../components/Reports/containers/Assignment/icons/decoding.png";
import phonemicIcon from "../../../../components/Reports/containers/Assignment/icons/phonemic.png";
import recognitionIcon from "../../../../components/Reports/containers/Assignment/icons/recognition.png";

export default function DomainIcon(props: { type: keyof typeof iconLookup }) {
  const { type } = props;

  return <img className="domain-icon" src={iconLookup[type]} />;
}

const iconLookup = {
  dyslexia: dyslexiaIcon,
  comprehension: comprehensionIcon,
  decoding: decodingIcon,
  phonemic: phonemicIcon,
  recognition: recognitionIcon,
};
